import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"
import { fetchSignalements } from "./notificationActions"

export const FETCH_INFORMATIONS_BEGIN = "FETCH_INFORMATIONS_BEGIN"
export const FETCH_INFORMATIONS_SUCCESS = "FETCH_INFORMATIONS_SUCCESS"
export const FETCH_INFORMATIONS_ERROR = "FETCH_INFORMATIONS_ERROR"

export const fetchInformationsBegin = () => ({
	type: FETCH_INFORMATIONS_BEGIN,
})

export const fetchInformationsSucces = (informations, append = false) => ({
	type: FETCH_INFORMATIONS_SUCCESS,
	payload: { informations, append },
})

export const fetchInformationsError = (error) => ({
	type: FETCH_INFORMATIONS_ERROR,
	payload: error,
})

// statut : actifs (défaut) | termines | tous.
// opts.limit/offset : pagination (page /signalements) — sans limit, on reçoit
// tout (rail du planning). opts.append : concatène au lieu de remplacer
// (« Charger plus »). opts.categorie : filtre par type_notification (le rail
// dispatch ne veut QUE les signalements). Le thunk résout avec le json reçu
// (permet au composant de savoir s'il reste des pages).
export function fetchInformations(statut = "actifs", opts = {}) {
	const { limit = null, offset = 0, append = false, categorie = null } = opts
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		// Poll : ne pas partir avec un `Bearer ` malformé après logout.
		if (!token) return Promise.resolve()
		dispatch(fetchInformationsBegin())
		let url = `${URL}api/informations?statut=${statut}`
		if (categorie) url += `&categorie=${categorie}`
		if (limit != null) url += `&limit=${limit}&offset=${offset}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchInformationsSucces(json, append))
				return json
			})
			.catch(catchApiError(dispatch, fetchInformationsError))
	}
}

// Marque un signalement comme terminé. Le backend lit du multipart
// (request.POST) → on envoie un FormData. On recharge ensuite la liste du
// statut courant (la réponse POST ne renvoie que les signalements actifs) ;
// fetchOpts est transmis au refetch (pagination de la page /signalements).
export function terminerSignalement(id, statut = "actifs", fetchOpts = {}) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		const form = new FormData()
		form.append("id", id)
		form.append("termine", "true")
		return fetch(`${URL}api/informations`, {
			method: "post",
			headers: { Authorization: `Bearer ${token}` },
			body: form,
		})
			.then(handleErrors)
			.then(() => {
				// Recharge la liste du contexte appelant + la cloche (dont le badge
				// compte les non-traités : il doit refléter le Terminer immédiatement).
				dispatch(fetchSignalements())
				return dispatch(fetchInformations(statut, fetchOpts))
			})
			.catch(catchApiError(dispatch, null))
	}
}
